export default {
  tel: '400-825-5211',
  wechat: '口袋故事家长号',
  list: [
    {
      id: 'Q1',
      title: '会员问题',
      iconUrl: 'https://img-ilisten.idaddy.cn/QA-app-user.png',
      hotIcon: false, // 是否开启热门角标
      list: [
        // Q1-1 怎么开通会员 Done
        {
          id: 'Q1-1',
          title: '怎么开通会员',
          keywords: ['购买', '开通', '会员', '订阅', 'VIP', 'VIP会员', '包月', '包季', '包年', '月卡', '季卡', '年卡', '连续订阅', '购买会员', '购买VIP', '购买VIP会员', '开通会员', '开通VIP', '开通VIP会员', '不能听会员内容', '想听会员内容', '怎么听会员内容', '不能听VIP内容', '想听VIP内容', '怎么听VIP内容', '开通故事会员', '开通知识会员'],
          contents: [
            {
              text: '口袋故事会员有<strong><font color=#FEB800>故事会员</font></strong>和<strong><font color=#60D090>知识会员</font></strong>两种类型，<strong><u>内容不通用，需单独开通</u></strong>。开通路径为：【我的 >（页面上方）立即开通】或者会员内容详情页底部引导按钮。',
            },
            {
              text: '<strong><font color=#FEB800>• 故事会员</font></strong>'
            },
            {
              text: '故事会员以人物、故事情节的儿童文学故事为主，偏重于通过故事的熏陶，丰富孩子的情感、体验、品格、社会认知，给孩子带来精神上的快乐。'
            },
            {
              text: '<strong><font color=#60D090>• 知识会员</font></strong>'
            },
            {
              text: '知识会员更专注在认知、学习、兴趣拓展等丰富的知识拓展方面。'
            },
            {
              text: '<strong>温馨提示：</strong>'
            },
            {
              text: '⒈由于会员服务为虚拟产品，<strong>暂不支持无理由退款</strong>。'
            },
            {
              text:'⒉若您在使用中遇到任何问题，如充值未到账，无法使用相关权益等情况，请提供<strong>充值账单截图</strong>，联系人工客服查询处理。'
            },
            {
              text:'⒊如果您是在<strong>第三方</strong>购买的会员，请联系<strong>购买的平台</strong>协商处理。'
            }
          ],
          relations: ['Q1-2', 'Q1-4', 'Q1-5', 'Q1-7']
        },
        // Q1-8 为什么会员不能听单购内容 Done
        {
          id: 'Q1-8',
          title: '为什么会员不能听单购内容',
          keywords:['会员', '单购', '不能听', '听不了', '单购故事', '单购内容', '包月', '包季', '包年', '月卡', '季卡', '年卡',],
          contents: [
            {
              text: '您好，由于版权方面的原因，部分内容无法纳入会员畅听范围。这部分内容在整个口袋故事内容库中仅占比不到3%。',
            },
            {
              text: '会员用户购买单购内容时可享受额外折扣。'
            }
          ],
          relations: ['Q1-1', 'Q1-7', 'Q1-11']
        },
        // Q1-11 开通会员和单独购买内容的区别 Done
        {
          id: 'Q1-11',
          title: '开通会员和单独购买内容的区别',
          keywords:['下载', '不能听', '下载故事', '单独购买', '单购', '购买故事', '购买故事', '单独购买故事', '单独购买内容', '有效期', '过期'],
          contents: [
            {
              text: '您好，如您开通了会员，在会员有效期内可畅享海量会员专属内容。会员到期后无法继续享有该权益（包括已下载到本地的会员内容）。',
            },
            {
              text: '单独购买的内容是永久有效的，可以在【我的 > 我的购买】中查看全部已购内容。',
            }
          ],
          relations: ['Q1-1', 'Q1-7', 'Q1-8']
        },
        // Q1-7 会员内容权益 Done
        {
          id: 'Q1-7',
          title: '会员内容权益',
          keywords:['畅听', '故事会员', '知识会员', '专属', '权益', '类型', '会员', 'VIP', 'VIP会员', '订阅', '包月', '包季', '包年', '月卡', '季卡', '年卡'],
          contents: [
            {
              text: '口袋<strong><font color=#FEB800>故事会员</font></strong>内容权益涵盖了超过6000个故事（音频为主），累计3.5万小时。'
            }, 
            {
              text: '口袋<strong><font color=#60D090>知识会员</font></strong>内容权益涵盖了约1000个课程（包括音频、视频），累计4千小时。'
            }, 
            {
              text: '口袋故事每周新增15部以上来自全球范围的优秀作品，我们竭力为您提供从婴幼启蒙到中学阶段的全方位少儿成长益智视听内容。'
            }
          ],
          relations: ['Q1-8', 'Q1-1', 'Q1-11']
        },
        // Q1-2 会员连续订阅 Done
        {
          id: 'Q1-2',
          title: '会员连续订阅',
          keywords:['自动', '连续', '订阅', '开通', '续费', '扣款', '连续订阅', '自动续费', '自动扣款', '连续包月', '连续包季', '连续包年', '包月', '包季', '包年', '月卡', '季卡', '年卡',],
          contents: [
            {
              text: '<strong>连续订阅</strong>是针对长期使用口袋故事的会员提供的便利性购买方案，可以享受更大的折扣价格。',
            },
            {
              text: '• 苹果设备仅支持使用苹果应用内购买开通连续订阅服务。开通后，系统会根据您选择的订阅服务类型（包月/季/年）<strong>在下一个扣费周期（包月/季/年）开始的前一天</strong>进行自动扣费。',
            },
            {
              text: '• 安卓设备支持使用微信支付开通连续订阅服务，开通后，系统会<strong>在会员到期的前一天</strong>进行自动扣费。'
            }
          ],
          relations: ['Q1-4', 'Q1-5', 'Q1-3', 'Q1-12']
        },
        // Q1-3 取消苹果连续订阅 Done
        {
          id: 'Q1-3',
          title: '取消苹果连续订阅',
          keywords:['关闭', '取消', '关闭连续包月', '关闭自动续费', '取消连续包月', '取消自动续费', '关闭连续订阅', '关闭自动扣款', '取消自动扣款', '续费', '扣款', '包月', '包季', '包年', '订阅', '自动续费', '自动扣款', '连续包月', '连续包季', '连续包年', '连续订阅'],
          contents: [
            {
              text: '您好，您可以按照以下路径取消苹果连续订阅：',
            },
            {
              text: '⒈苹果iOS14系统以下：点击手机中的【设置―iTunes Store与App Store-Apple ID-查看Apple ID-订阅】可找到对应订阅并操作取消。',
            },
            {
              text: '⒉苹果iOS14系统以上：点击手机中的【设置-头像-媒体与购买项目-查看账户-订阅】，操作取消即可。',
            },
            {
              text: '<strong>温馨提示：</strong>取消连续订阅不影响已经购买的会员使用，若您未找到取消的按钮，请联系人工客服核实处理。'
            }
          ],
          relations: ['Q1-12', 'Q1-5', 'Q1-4', 'Q1-2']
        },
        // Q1-12 取消微信连续订阅 Done
        {
          id: 'Q1-12',
          title: '取消微信连续订阅',
          keywords:['关闭', '取消', '关闭连续包月', '关闭自动续费', '取消连续包月', '取消自动续费', '关闭连续订阅', '关闭自动扣款', '取消自动扣款', '续费', '扣款', '包月', '包季', '包年', '订阅', '自动续费', '自动扣款', '连续包月', '连续包季', '连续包年', '连续订阅'],
          contents: [
            {
              text: '如您是当前登录账号开通的连续订阅，请点击>><a href="https://ilisten.idaddy.cn/vip/subscribeOn">【订阅管理】</a>或从【我的 >（页面上方）立即开通 >（页面上方）已开通连续订阅图标 > 订阅管理】。<strong>温馨提示：</strong>如果上述路径没有找到入口，或者订阅管理页面提示未查询到订阅，则表示当前账号未开通订阅。',
            },
            {
              text: '如您不知晓订阅账号，请打开微信APP，点击【我 > 服务 > 钱包 > 支付设置 > 自动续费 > 关闭】，操作取消连续订阅。',
            },
            {
              text: '<strong>温馨提示：</strong>取消连续订阅不影响已经购买的会员使用，若您未找到取消的按钮，请联系人工客服核实处理。'
            }
          ],
          relations: ['Q1-3', 'Q1-5', 'Q1-6']
        },
        // Q1-4 会员套餐区别 Done
        {
          id: 'Q1-4',
          title: '会员套餐区别',
          keywords:['类型', '会员', 'VIP', 'VIP会员', '订阅', '套餐', '一个月', '一年', '故事会员', '知识会员', '包月', '包季', '包年', '月卡', '季卡', '年卡'],
          contents: [
            {
              text: '点击【我的 >（页面上方）立即开通】查看会员套餐详情，根据您的需求进行购买即可。<strong>会员套餐/价格，以页面显示为准。</strong>'
            },
            {
              text: '口袋故事会员有<strong><font color=#FEB800>故事会员</font></strong>和<strong><font color=#60D090>知识会员</font></strong>两种类型，<strong>内容不通用，需单独开通</strong>。相同类型下根据套餐（月卡/包月、季卡/包季、年卡/包年）的价格，会员时长有所不同，但<strong>会员权益是没有区别</strong>的。'
            },
            {
              text: '购买连续订阅套餐（包月、包季、包年）时，页面有自动续费相关的详细说明及《会员连续订阅协议》，请留意查看。'
            },
          ],
          relations: ['Q1-1', 'Q1-7', 'Q1-5']
        },
        // Q1-5 叠加购买的会员时间如何计算 Done
        {
          id: 'Q1-5',
          title: '叠加购买的会员时间如何计算',
          keywords:['会员', 'VIP', 'VIP会员', '订阅', '包月', '包季', '包年', '月卡', '季卡', '年卡', '叠加', '累加', '时长', '计算'],
          contents: [
            {
              text: '口袋故事支持<strong>故事会员</strong>和<strong>知识会员</strong>同时开通，且购买<strong><font color="orange">同类会员</font></strong>后系统会<strong><font color="orange">自动延续会员时长</font></strong>。比如：您于3月20日开通了1个月故事会员，随后又购买了3个月故事会员，那么您的故事会员有效期会自动延续至7月20日。'
            },
          ],
          relations: ['Q1-6', 'Q1-1']
        },
        // Q1-6 如何查看会员到期时间 Done
        {
          id: 'Q1-6',
          title: '如何查看会员到期时间',
          keywords:['会员', 'VIP', 'VIP会员', '包月', '包季', '包年', '月卡', '季卡', '年卡', '叠加', '累加', '时长', '有效', '有效期', '到期'],
          contents: [
            {
              text: '您好，请先登录口袋故事账号，点击【我的】按钮：'
            },
            {
              text: '• 如若您<strong>未开通连续订阅</strong>，可以直接在页面上方查看会员到期时间。'
            },
            {
              text: '• 如若您<strong>已开通连续订阅</strong>，页面上方会显示<strong>已开通连续订阅</strong>，系统将会按照订阅时间定期扣费。'
            },
            {
              text: '温馨提示：若对<strong>会员到期时间</strong>有异议，请联系人工客服核实处理。'
            }
          ],
          relations: ['Q1-5', 'Q1-1', 'Q1-2']
        },
      ]
    },
    {
      id: 'Q2',
      title: '账号问题',
      iconUrl: 'https://img-ilisten.idaddy.cn/QA-app-account.png',
      hotIcon: false, // 是否开启热门角标
      list: [
        // Q2-1 绑定手机号和微信 Done
        {
          id: 'Q2-1',
          title: '如何绑定手机号和微信',
          keywords: ['账号', '绑定', '手机', '手机号', '微信', '绑定微信', '绑定手机'],
          contents: [
            {
              text: '您好，您可以点击【我的 > (页面右上角)设置 > 账户与安全 > 绑定手机/绑定微信】根据页面提示操作绑定手机号和微信。',
            }
          ],
          relations: ['Q2-3', 'Q2-9']
        },
        // Q2-3 如何换绑手机号 Done
        {
          id: 'Q2-3',
          title: '如何换绑手机号',
          keywords:['账号', '绑定', '手机', '手机号', '微信', '更换', '更换绑定', '更换手机', '更换手机号', '更换微信', '更换微信号'],
          contents: [
            {
              text: '您好，您可以点击【我的 > (页面右上角)设置 > 账户与安全 > 绑定手机】根据页面提示操作换绑手机号。',
            },
            {
              text: '若您由于更换手机号码或手机遗失等原因无法自助完成账号换绑。请按页面底部联系方式联系客服，我们会协助您完成操作。',
            }
          ],
          relations: ['Q2-9', 'Q2-10', 'Q2-6']
        },
        // Q2-4 如何登录账号 Done
        {
          id: 'Q2-4',
          title: '如何登录账号',
          keywords:['登录', '注册', '微信', '微博', '手机', '手机号', 'QQ', 'QQ号'],
          contents: [
            {
              text: '您好，您可以点击【我的 > (页面上方)点击登录】根据提示选择：',
            },
            {
              text: '⒈<strong>继续此账号登录：</strong>使用当前设备上次登录的账号进行登录。'
            },
            {
              text: '⒉<strong>切换账号：</strong>您可以选择其它登录方式或账号进行登录（口袋故事支持<strong>微信、手机号、账号ID</strong>等多种方式登录）。'
            },
            {
              text: '温馨提示：为保障您的账号安全，防止您遗忘账号而造成损失，口袋故事强烈建议您将账号绑定手机号，或者直接使用手机号注册。'
            }
          ],
          relations: ['Q2-1']
        },
        // Q2-6 手机收不到短信验证码 Done
        {
          id: 'Q2-6',
          title: '手机收不到短信验证码',
          keywords:['收不到', '收不了', '没有', '不能', '不能收到', '没有收到', '短信', '验证码', '短信验证码', '收不到短信', '收不到验证码', '收不到短信验证码', '收不了短信', '收不了验证码', '收不了短信验证码', '没有收到短信', '没有收到验证码', '没有收到短信验证码', '不能收到短信', '不能收到短信', '不能收到短信验证码'],
          contents: [
            {
              text: '您好，以下情况可能导致手机接收不到短信验证码：',
            },
            {
              text: '⒈<strong>网络信号差：</strong>建议您更换网络环境后重新尝试。'
            },
            {
              text: '⒉<strong>每日上限：</strong>您可能在短时间内多次操作发送验证码，达到每日上限，建议您在 24 小时后重新尝试。'
            },
            {
              text: '⒊<strong>短信被拦截：</strong>建议您确认短信是否被系统或者其它安全软件当做垃圾短信拦截。'
            },
            {
              text: '若上述方案仍未解决您的问题，请按页面底部联系方式联系客服，我们会协助您完成操作。'
            }
          ],
          relations: ['Q2-1', 'Q2-3']
        },
        // Q2-8 如何注册账号 Done
        {
          id: 'Q2-8',
          title: '如何注册账号',
          keywords:['注册', '账号注册', '注册账号'],
          contents: [
            {
              text: '您好，口袋故事APP注册登录后可享更多权益。口袋故事账号支持的注册方式有：',
            },
            {
              text: '⒈手机号码（仅支持中国大陆地区 11 位手机号）；<br>⒉微信账号；<br>⒊华为账号（仅限华为设备）；<br>⒋AppleID（仅苹果设备）。'
            },
            {
              text: '温馨提示：口袋故事无法直接识别微信账号与手机号码的关联。即使您的微信账号与手机号码相同，仍然需要您手动分别绑定手机号和微信账号。'
            }
          ],
          relations: ['Q2-3', 'Q2-9']
        },
        // Q2-9 如何找回自己的账号 Done
        {
          id: 'Q2-9',
          title: '如何找回自己的账号',
          keywords:['找不到', '搞不清', '不知道', '忘记', '不记得', '账号', '以前', '之前', '登录', '注册', '找不到账号', '找不到登录账号', '搞不清账号', '搞不清登录账号', '不知道账号', '不知道登录账号', '忘记账号', '忘记登录账号', '不记得账号', '不记得登录账号'],
          contents: [
            {
              text: '您好，您可以按照以下方式尝试自助找回您的账号：',
            },
            {
              text: '⒈尝试分别使用微信和手机号登录。即使您的微信账号与手机号码相同，APP也无法直接识别关联，<strong>导致创建了两个不同账号</strong>；'
            },
            {
              text: '⒉查看当前<a href="ilisten:///user/loginhist">手机登录历史</a>。'
            },
            {
              text: '温馨提示：为保障您的账号安全，防止您遗忘账号而造成损失，口袋故事强烈建议您将账号绑定手机，或者直接使用手机号注册。'
            }
          ],
          relations: ['Q2-1', 'Q2-6']
        },
        // Q2-10 忘记密码 Done
        {
          id: 'Q2-10',
          title: '忘记密码怎么办',
          keywords:['找不到', '搞不清', '不知道', '忘记', '不记得', '账号', '以前', '之前', '登录', '注册', '密码', '找不到账号', '找不到登录账号', '找不到密码', '搞不清账号', '搞不清登录账号', '搞不清密码', '不知道账号', '不知道登录账号', '不知道密码', '忘记账号', '忘记登录账号', '忘记密码', '不记得账号', '不记得登录账号', '不记得密码'],
          contents: [
            {
              text: '您好，若您的账号已绑定手机号，可以直接通过手机号找回密码。若您的账号尚未绑定手机号，请按页面底部联系方式联系客服，我们会协助您完成操作。',
            },
            {
              text: '温馨提示：<br>为保障您的账号安全，防止您遗忘账号而造成损失，口袋故事强烈建议您将账号绑定手机，或者直接使用手机号注册。'
            }
          ],
          relations: ['Q2-1']
        },
      ]
    },
    {
      id: 'Q3',
      title: '功能问题',
      iconUrl: 'https://img-ilisten.idaddy.cn/QA-app-function.png',
      hotIcon: false, // 是否开启热门角标
      list: [
        // Q3-1 充值币的用途 Done
        {
          id: 'Q3-1',
          title: '充值币的用途',
          keywords: ['充值币', '工爸币', '充值', '金币', '虚拟币', '货币', '虚拟币', '买故事', '购买故事', '怎么买故事', '怎么单购', '怎么单购故事'],
          contents: [
            {
              text: '充值币是口袋故事平台的虚拟货币，可以用于购买口袋故事内的付费内容、会员商品。',
            },
            {
              text: '• 付费内容：包括<strong>付费音频、付费视频、付费漫画。</strong>'
            },
            {
              text: '• 会员商品：包括<strong>故事会员</strong>和<strong>知识会员</strong>'
            },
            {
              text: '温馨提示：因苹果支付政策，目前口袋故事APP苹果端<strong><font color="orange">不支持</font></strong>使用充值币购买会员。'
            }
          ],
          relations: ['Q3-2']
        },
        // Q3-2 如何获得充值币 Done
        {
          id: 'Q3-2',
          title: '如何获得充值币',
          keywords:['充值币', '工爸币', '充值', '金币', '虚拟币', '货币', '虚拟币',],
          contents: [
            {
              text: '您好，充值币仅可通过充值获得。点击【我的 >（我的相关）钱包资产 > 钱包充值】选择下方充值金额进行支付即可。',
            },
            {
              text: '温馨提示：充值的过程中，口袋故事可能会奖励您一些额外的充值币，这部分属于赠送币，和充值币无区别，同样可用于购买故事和会员。'
            }
          ],
          relations: ['Q3-1', 'Q3-3']
        },
        // Q3-3 充值未到账 Done
        {
          id: 'Q3-3',
          title: '充值未到账',
          keywords:['充值币', '工爸币', '充值', '金币', '虚拟币', '货币', '虚拟币', '未到账', '余额', '不到账'],
          contents: [
            {
              text: '您好，由于网络或其它不确定因素，充值币到账时间可能有几分钟的延迟。若等待超过 30 分钟还没有到账：',
            },
            {
              text: '⒈若您使用苹果设备充值未到账，请您进入您注册 Apple ID 时填写的邮箱，在邮箱内找到充值收据，标题是【Apple提供的收据】，发件人是【Apple】，截图并联系在线客服，我们会为您处理；'
            },
            {
              text: '⒉若您使用微信、支付宝充值未到账，请您找到对应的订单信息，截图并联系在线客服，我们会为您处理。'
            }
          ],
          relations: ['Q3-2', 'Q3-1']
        },
        // Q3-4 兑换兑换码 Done
        {
          id: 'Q3-4',
          title: '兑换兑换码',
          keywords:['兑换', '兑换码', '如何兑换', '如何兑换兑换码', '兑换码怎么用', '怎么兑换', '怎么兑换兑换码', '怎么'],
          contents: [
            {
              text: '您好，目前有两种兑换途径：',
            },
            {
              text: '⒈安卓设备：点击【我的 >（更多服务）兑换码】输入兑换码进行兑换；'
            },
            {
              text: '⒉苹果设备：请您关注【口袋故事服务号】，点击菜单【我的】>【兑换码】。<font color="orange">兑换前，请先确认微信账号已绑定到您希望兑换的口袋故事账号下</font>。'
            },
            {
              text: '温馨提示：兑换码有兑换时间限制，使用前请您仔细确认兑换码相关信息，如您确认符合条件，但仍然无法兑换，请按页面底部联系方式联系客服，我们会协助您完成操作。'
            }
          ],
          relations: []
        },
        // Q3-5 音频可以导出吗 Done
        {
          id: 'Q3-5',
          title: '音频可以导出吗',
          keywords:['离线', '导出', '文件', '音频导出', '音频文件', '离线音频'],
          contents: [
            {
              text: '您好，口袋故事APP所有内容资源均不支持导出。您下载的音频可以进行离线收听，但不能导出。',
            }
          ],
          relations: []
        },
        // Q3-6 如何在商城中使用优惠码购买商品 Pass
        {
          id: 'Q3-6',
          title: '如何在商城中使用优惠码购买商品',
          keywords: ['优惠码, 商城'],
          contents: [
            {
              text: '您好，您可以按照以下步骤使用优惠码购买商品：<br><br>1、点击商品页右下角的“立即购买”按钮进行购买；',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q3-6-1.png'
            },
            {
              text: '2、进入到确定订单页后，点击商品介绍下的“优惠券”一栏选择优惠券；',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q3-6-2.png'
            },
            {
              text: '3、页面弹出“请选择优惠券”弹框，在“请输入优惠码”的输入框中输入优惠码后，点击“兑换”按钮，兑换优惠券；',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q3-6-3.png'
            },
            {
              text: '',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q3-6-4.png'
            },
            {
              text: '4、优惠券兑换成功后，点击右下角“完成”按钮，使用优惠券；',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q3-6-5.png'
            },
            {
              text: '5、点击右下角“提交订单”按钮，以券后价完成购买商品。',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q3-6-6.png'
            },
          ],
          relations: []
        }
      ]
    },
    {
      id: 'Q4',
      title: '订单问题',
      iconUrl: 'https://img-ilisten.idaddy.cn/QA-app-order.png',
      hotIcon: false, // 是否开启热门角标
      list: [
        // Q4-1 故事订单查询
        {
          id: 'Q4-1',
          title: '查询我的订单',
          keywords: ['订单', '查看订单', '查询订单', '我的订单'],
          contents: [
            {
              text: '您好，您可以点击【我的 >（我的相关）我的订单】查看账号下全部订单。',
            },
            {
              text : '>温馨提示：如果您找不到之前已购买的故事，请先确认您的登录方式～'
            }
          ],
          relations: ['Q2-8', 'Q2-9']
        },
      ]
    },
    {
      id: 'Q5',
      title: '播放问题',
      iconUrl: 'https://img-ilisten.idaddy.cn/QA-app-play.png',
      hotIcon: false, // 是否开启热门角标
      list: [
        // Q5-1 会员到期后下载的会员内容是否可听 Done
        {
          id: 'Q5-1',
          title: '会员到期后下载的会员内容是否可听',
          keywords: ['下载', '不能听', '已下载', '播放', '下载故事', '已下载故事', '有效期', '过期', '下载故事不能听', '已下载故事不能听', '下载故事不能播放', '已下载故事不能播放'],
          contents: [
            {
              text: '您好，会员到期后无法继续享有畅听权益，已下载的会员内容也无法继续收听。',
            },
            {
              text: '温馨提示：您单独购买的故事是永久有效的，没有有效期。'
            }
          ],
          relations: ['Q1-6', 'Q1-11']
        },
        // Q5-2 定时播放 Done
        {
          id: 'Q5-2',
          title: '定时播放',
          keywords:['播放', '定时', '定时播放', '如何定时播放', '睡眠模式'],
          contents: [
            {
              text: '您好，在播放界面点击闹钟图标，可以设置定时播放。',
            }
          ],
          relations: []
        },
        // Q5-3 单独购买的故事可以随时下载吗 Done
        {
          id: 'Q5-3',
          title: '单独购买的故事可以随时下载吗',
          keywords:['单独购买', '下载'],
          contents: [
            {
              text: '您好，您单独购买的故事是永久有效的，您可以随时下载和收听。',
              picUrl: ''
            }
          ],
          relations: ['Q1-11', 'Q5-1']
        },
      ]
    },
    {
      id: 'Q6',
      title: '设备常见问题',
      iconUrl: 'https://img-ilisten.idaddy.cn/QA-app-device.png',
      hotIcon: true, // 是否开启热门角标
      list: [
        // Q2-5 账号可以多设备使用吗 Done
        {
          id: 'Q2-5',
          title: '账号可以多设备使用吗',
          keywords:['多设备', '多台设备', '几台设备', '一个账号可以登录几台设备', '登录', '登录账号', '设备'],
          contents: [
            {
              text: '您好，口袋故事账号支持多设备登录和使用，具体规则如下：',
            },
            {
              text: '<strong>同一时间使用：</strong>一个账号只能同时在<strong><font color="orange">2台</font></strong>设备使用。',
            },
            {
              text: '<strong>非同时使用：</strong>一个账号最多可以授权<strong><font color="orange">5台</font></strong>设备登录，第6台设备登录时，最早授权的设备将被强制退出登录。'
            }
          ],
          relations: ['Q6-1', 'Q2-2']
        },
        // Q2-2 设备如何登录账号 Done
        // {
        //   id: 'Q2-2',
        //   title: '如何多设备登录账号',
        //   keywords:['多设备', '多台设备', '几台设备', '一个账号可以登录几台设备', '登录', '登录账号', '设备'],
        //   contents: [
        //     {
        //       text: '您好，您可以通过以下方式授权',
        //     },
        //     {
        //       text: '⒈<strong>账号密码登录：</strong>您可以在口袋故事手机 APP 登录页选择【已有账号】，输入您的口袋故事账号和登录密码进行登录；'
        //     },
        //     {
        //       text: '⒉<strong>微信登录：</strong>您可以在口袋故事手机 APP 登录页选择【微信】，跳转手机微信 APP 进行授权登录（注：请确保手机中已安装微信 APP 并已登录账号绑定的微信）；'
        //     },
        //     {
        //       text: '⒊<strong>手机号码登录</strong>：您可以在口袋故事手机 APP 登录页输入账号绑定的手机号，获取动态验证码登录。'
        //     },
        //     {
        //       text: '温馨提示：为保障您的账号安全，防止您遗忘账号而造成损失，口袋故事强烈建议您将账号绑定手机，或者直接使用手机号注册。'
        //     }
        //   ],
        //   relations: ['Q6-1', 'Q2-1', 'Q2-4', 'Q2-5']
        // },
        // Q6-1 口袋故事支持的终端 Pass
        {
          id: 'Q6-1',
          title: '口袋故事支持的终端',
          keywords: ['设备', '支持设备', '支持的设备', '终端', '智能设备'],
          contents: [
            {
              text: '口袋故事目前已支持市面大部分品牌的儿童手表、平板/学习机、听力熊学习机及部分智能汽车。',
              picUrl: ''
            },
            {
              text: '<b>儿童手表</b><br>口袋故事支持小天才、华为、小寻、小米、360、oppo、西瓜皮、糖猫、Kido、优学派、天奕达、阿巴町、读书郎等 30 余个品牌的儿童手表。<br><a href="https://ilisten.idaddy.cn/ilisten-h5/helpdetail?id=Q6-2">手表口袋故事如何登录？</a>',
              picUrl: ''
            },
            {
              text: '<b>平板/学习机</b><br>口袋故事支持读书郎、优学派、步步高、华为、小寻、讯飞等 20 余个品牌的平板学习机。<br><a href="https://ilisten.idaddy.cn/ilisten-h5/helpdetail?id=Q6-3">平板/学习机口袋故事如何登录？</a>',
              picUrl: ''
            },
            {
              text: '<b>智能车载</b><br>口袋故事支持理想汽车、北京汽车、长城汽车、小鹏P5/P7/G3i、问界M5、奥迪A4L等。<br><a href="https://ilisten.idaddy.cn/ilisten-h5/helpdetail?id=Q6-4">车载口袋故事如何登录？</a>',
              picUrl: ''
            },
            {
              text: '<b>其它终端</b><br>口袋故事支持听力熊学习机。<br><a href="https://ilisten.idaddy.cn/ilisten-h5/helpdetail?id=Q6-5">听力熊口袋故事如何登录？</a>',
              picUrl: ''
            },
          ],
          relations: ['Q6-2', 'Q6-3', 'Q6-4', 'Q6-5']
        },
        // Q6-2 手表口袋故事如何登录 Pass
        {
          id: 'Q6-2',
          title: '手表口袋故事如何登录',
          keywords:['手表', '登录', '扫码', '二维码', '手表登录', '手表扫码', '手表二维码', '儿童手表登录', '儿童手表扫码','小天才', '小天才手表', '小寻', '小寻手表', '华为', '华为手表', '小米', '小米手表', '设备', '设备登录', '设备扫码'],
          contents: [
            {
              text: '您好，手表口袋故事需要借助手机扫码登录，您可以：<br>① <a href="ilisten:///scan?scene=qr_login">点击扫码登录</a><br>② 使用手机微信扫码登录',
              picUrl: ''
            },
            {
              text: '<b>如何找到登录二维码？</b><br>打开手表端口袋故事应用后，您可以按照以下方式找到登录二维码：<br><b>支持广场版本</b>',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q6-2-1.jpg'
            },
            {
              text: '① 首页左滑到「我的」页<br>② 点击「未登录」，进入二维码页<br><b>其它版本</b>',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q6-2-2.jpg'
            },
            {
              text: '① 点击首页左上角「未登录」，进入二维码页',
              picUrl: ''
            }
          ],
          relations: ['Q6-3', 'Q6-4', 'Q6-5']
        },
        // Q6-3 平板/学习机如何登录 Pass
        {
          id: 'Q6-3',
          title: '平板/学习机如何登录',
          keywords:['平板', '学习机', '登录', '扫码', '二维码', '平板登录', '平板扫码', '平板二维码', '学习机登录', '学习机扫码', '学习机二维码', '步步高', '设备', '设备登录', '设备扫码'],
          contents: [
            {
              text: '您好，平板/学习机口袋故事应用支持多种登录方式：<br>① <a href="ilisten:///scan?scene=qr_login">点击扫码登录</a><br>② 使用手机微信扫码登录<br>③ 手机号验证码登录<br>④ 微信一键登录（注：需要平板/学习机已安装微信）',
              picUrl: ''
            },
            {
              text: '<b>如何找到登录页？</b><br>打开口袋故事应用后，点击首页左上角「默认头像」进入登录页：',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q6-3-1.jpg'
            }
          ],
          relations: ['Q6-2', 'Q6-4', 'Q6-5']
        },
        // Q6-4 车载口袋故事如何登录 Pass
        {
          id: 'Q6-4',
          title: '车载口袋故事如何登录',
          keywords:['车载', '理想汽车', '理想', '汽车', '登录', '扫码', '二维码', '车载登录', '车载扫码', '车载二维码', '设备', '设备登录', '设备扫码'],
          contents: [
            {
              text: '您好，车载口袋故事需要借助手机扫码登录，您可以：<br>① <a href="ilisten:///scan?scene=qr_login">点击扫码登录</a><br>② 使用手机微信扫码',
              picUrl: ''
            },
            {
              text: '<b>如何找到登录二维码？</b><br>口袋故事已入驻多个汽车品牌和车载平台，不同版本略有差异：<br>① <a href="https://ilisten.idaddy.cn/ilisten-h5/helpdetail?id=Q6-6">理想汽车如何登录？</a><br>② <a href="https://ilisten.idaddy.cn/ilisten-h5/helpdetail?id=Q6-7">华为智选如何登录？</a><br>③ 其它车载登录二维码路径如下：',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q6-4-1.jpg'
            },
            {
              text: '① 找到首页「我的」入口，进入个人中心（左上角头像或者左侧菜单栏底部按钮）<br>② 点击左上方「未登录」，进入二维码页',
              picUrl: ''
            }
          ],
          relations: ['Q6-6', 'Q6-7', 'Q6-2', 'Q6-3', 'Q6-5']
        },
        // Q6-5 听力熊口袋故事如何登录 Pass
        {
          id: 'Q6-5',
          title: '听力熊口袋故事如何登录',
          keywords:['学习机', '听力熊', '登录', '扫码', '二维码', '听力熊登录', '听力熊扫码', '听力熊二维码', '设备', '设备登录', '设备扫码'],
          contents: [
            {
              text: '您好，听力熊口袋故事需要借助手机扫码登录，您可以：<br>① <a href="ilisten:///scan?scene=qr_login">点击扫码登录</a><br>② 使用手机微信扫码',
              picUrl: ''
            },
            {
              text: '<b>如何找到登录二维码？</b><br>打开口袋故事后，你可以按照以下路径找到登录二维码：',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q6-5-1.jpg'
            },
            {
              text: '① 点击桌面「品牌专区」<br>② 点击列表中的「口袋故事」，进入应用<br>③ 点击顶部「分类故事」导航，进入二维码页',
              picUrl: ''
            }
          ],
          relations: ['Q6-6', 'Q6-7', 'Q6-2', 'Q6-3', 'Q6-5']
        },
        // Q6-6 理想口袋故事如何登录 Pass
        {
          id: 'Q6-6',
          title: '理想口袋故事如何登录',
          keywords:['车载', '理想汽车', '理想', '汽车', '登录', '扫码', '二维码', '理想登录', '理想扫码', '理想二维码', '车载登录', '车载扫码', '车载二维码', '设备', '设备登录', '设备扫码'],
          contents: [
            {
              text: '您好，理想口袋故事需要借助手机扫码登录，您可以：<br>① <a href="ilisten:///scan?scene=qr_login">点击扫码登录</a><br>② 使用手机微信扫码',
              picUrl: ''
            },
            {
              text: '<b>如何找到登录二维码？</b><br>打开口袋故事后，您可以按照以下方式找到登录二维码：',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q6-6-1.jpg'
            },
            {
              text: '① 点击左侧菜单栏「我的」<br>② 点击右上方「立即登录」按钮，进入设置页<br>③ 点击右上方「立即登录」按钮，进入二维码页',
              picUrl: ''
            }
          ],
          relations: ['Q6-4', 'Q6-7', 'Q6-2', 'Q6-3', 'Q6-5']
        },
        // Q6-7 华为智选如何登录 Pass
        {
          id: 'Q6-7',
          title: '华为智选如何登录',
          keywords:['车载', '华为智选', '华为', '汽车', '登录', '扫码', '二维码', '车载登录', '车载扫码', '车载二维码', '设备', '设备登录', '设备扫码'],
          contents: [
            {
              text: '您好，华为智选口袋故事需要借助手机扫码登录，您可以：<br>① <a href="ilisten:///scan?scene=qr_login">点击扫码登录</a><br>② 使用手机微信扫码',
              picUrl: ''
            },
            {
              text: '<b>如何找到登录二维码？</b><br>打开口袋故事后，您可以按照以下方式找到登录二维码：',
              picUrl: 'https://img-ilisten.idaddy.cn/QA-app-Q6-7-1.jpg'
            },
            {
              text: '① 点击顶部导航「我的」<br>② 点击左上方「会员中心」，进入二维码页',
              picUrl: ''
            }
          ],
          relations: ['Q6-4', 'Q6-6', 'Q6-2', 'Q6-3', 'Q6-5']
        },
        // Q6-8 设备如何退出登录 Done
        {
          id: 'Q6-8',
          title: '设备如何退出登录',
          keywords:['设备', '退出登录', '解除授权', '解绑', '解除', '取消授权'],
          contents: [
            {
              text: '您好，不同设备和口袋故事版本退出登录方式略有不同，您可以参考以下流程：',
            },
            {
              text: '<strong>• 儿童手表：</strong>打开手表口袋故事应用后，点击【（首页左上角）头像/页面右滑 > 我的 > 上滑页面 > 切换账号】根据提示操作退出登录。'
            },
            {
              text: '<strong>• 平板/学习机：</strong>打开平板/学习机口袋故事应用后，点击【（首页左上角）头像 >（更多服务）设置 > 退出登录】根据提示操作退出登录。'
            },
            {
              text: '<strong>• 理想汽车：</strong>打开理想汽车口袋故事应用后，点击【我的 > 设置 > 退出登录】根据提示操作退出登录。'
            },
            {
              text: '<strong>• 华为智选：</strong>打开华为智选口袋故事应用后，点击【我的 > 设置 > 退出登录】根据提示操作退出登录。'
            },
            {
              text: '<strong>• 其它车载：</strong>打开车载端口袋故事应用后，点击【（首页左上角）头像 >（更多服务）设置 > 退出登录】根据提示操作退出登录。'
            },
            {
              text: '<strong>• 听力熊：</strong>打开听力熊口袋故事应用后，点击【（首页右上角）我的 > 头像 > 解除绑定】根据提示操作退出登录。'
            },
            {
              text: '温馨提示：若您未找到设备退出登录按钮，请按页面底部联系方式联系客服，我们会协助您完成操作。'
            }
          ],
          relations: ['Q6-1', 'Q2-5']
        },
        // Q2-11 设备登录账号如何绑定手机 Done
        {
          id: 'Q2-11',
          title: '设备登录账号如何绑定手机',
          keywords:['设备账号', '绑定手机', '设备登录'],
          contents: [
            {
              text: '您好，若您设备已登录的口袋故事账号未绑定手机号，您需要先为其绑定手机号，流程如下：',
            },
            {
              text: '⒈使用手机微信APP扫描设备二维码进入会员中心（部分渠道扫码后需要关注口袋故事家长号，点击推送内容）；'
            },
            {
              text: '⒉点击【更多/家长中心 > 绑定手机】根据页面提示操作绑定手机号。'
            },
            {
              text: '温馨提示：若您未找到绑定手机按钮，请按页面底部联系方式联系客服，我们会协助您完成操作。'
            }
          ],
          relations: ['Q6-1', 'Q2-5']
        },
      ]
    }
  ]
}
